import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import blackOut from '../images/blackout.jpg'
import printvelvet from '../images/print-velvet.jpg'
import sheer from '../images/sheer.jpg'
import { Link } from 'react-router-dom'

export default function DisplayProduct() {
    return (
        <Container className='py-5 mt-5' id='products'>
            <h1 className='text-center'>Featured Products</h1>
            <Row className='mt-5'>
                <Col md={4} className='pb-4'>
                    <Link to={'/gallery/2'} className="courses-list-item position-relative d-block overflow-hidden mb-2" >
                        <img className="activity-img" src={printvelvet} alt="" />
                        <div className="courses-text">
                            <h4 className="text-center text-white px-3">Velvet Fabric</h4>

                        </div>
                    </Link>
                </Col>
                <Col md={4} className='pb-4'>
                    <Link to={'/gallery/2'} className="courses-list-item position-relative d-block overflow-hidden mb-2" >
                        <img className="activity-img" src={blackOut} alt="" />
                        <div className="courses-text">
                            <h4 className="text-center text-white px-3">Blackout Fabric</h4>

                        </div>
                    </Link>
                </Col>
                <Col md={4} className='pb-4'>
                    <Link to={'/gallery/2'} className="courses-list-item position-relative d-block overflow-hidden mb-2" >
                        <img className="activity-img" src={sheer} alt="" />
                        <div className="courses-text">
                            <h4 className="text-center text-white px-3">Sheer Fabric</h4>

                        </div>
                    </Link>
                </Col>

            </Row>
        </Container>
    )
}
